import { StaffType } from './staff.model';

export type StaffPlantillaOperation = 'alta' | 'baja';

export const STAFF_PLANTILLA_FILE_NAMES: Record<
  StaffPlantillaOperation,
  Record<StaffType, string>
> = {
  alta: {
    LE: 'plantilla_carga_staff_le.xlsx',
    GES: 'plantilla_carga_staff_ges.xlsx',
  },
  baja: {
    LE: 'plantilla_baja_staff_le.xlsx',
    GES: 'plantilla_baja_staff_ges.xlsx',
  },
};

export interface StaffPlantillaFile {
  readonly blob: Blob;
  readonly fileName: string;
  readonly contentType: string;
}
